<template>
  <div class="post-list-container">
    <PostItem v-for="(item, index) in props.data" :key="index" :data="item" />
  </div>
</template>

<script lang="ts" setup>
import { withDefaults } from 'vue'
import PostItem from './PostItem.vue'
interface Props {
  data: any[]
}
const props = withDefaults(defineProps<Props>(), {
  data: () => []
})
</script>
